import { Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalDismissStatus } from '../../../distribution/models/modal-dismiss-status';
import { AlertEvent } from "../../models/alert-event";
import { DateTimeService } from "../../../shared/datetime/datetime.service";
import { DxDataGridModule } from "devextreme-angular";
import { DxoColumnFixingModule, DxiColumnModule } from "devextreme-angular/ui/nested";
import { DxTemplateModule } from "devextreme-angular/core";
import { StatusTrafficLightComponent } from "../../../shared/status-traffic-light/status-traffic-light.component";

@Component({
    templateUrl: './alert-configuration-history-dialog.component.html',
    styleUrls: ['./alert-configuration-history-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, DxoColumnFixingModule, DxiColumnModule, DxTemplateModule, StatusTrafficLightComponent]
})
export class AlertConfigurationHistoryDialogComponent {

    public alertEvents: AlertEvent[] = [];

    constructor(
        public modal: NgbActiveModal,
        public dateTimeService: DateTimeService){
        }

    cancel(): void {
        this.modal.dismiss(ModalDismissStatus.Cancel);
    }
}
